import React from "react";

type PrimaryButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean | undefined;
  className?: string;
};

const PrimaryButton: React.FC<PrimaryButtonProps> = React.memo(({
  children,
  onClick,
  type = "button",
  disabled = false,
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        h-9 px-4 text-sm font-medium
        text-white
        bg-[#1d365d]
        hover:bg-[#2d4a75]
        transition-colors
        disabled:opacity-60 disabled:cursor-not-allowed
        rounded-lg
        ${className}
      `}
    >
      {children}
    </button>
  );
});

export default PrimaryButton;
